import { render, staticRenderFns } from "./ProblemList.vue?vue&type=template&id=07b9177d&scoped=true"
import script from "./ProblemList.vue?vue&type=script&lang=js"
export * from "./ProblemList.vue?vue&type=script&lang=js"
import style0 from "./ProblemList.vue?vue&type=style&index=0&id=07b9177d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b9177d",
  null
  
)

export default component.exports